import { Dispatch, SetStateAction, useState } from 'react'
import { AutocompleteItem } from 'interfaces/algolia'
import SearchMap, { Bounds } from './SearchMap'
import { SearchMapLocationContent } from './SearchMapContainer.style'
import { SearchStaticMap } from './SearchStaticMap'

interface SearchMapContainerProps {
  geoJson: GeoJSON.FeatureCollection<GeoJSON.Point, AutocompleteItem>
  defaultFullScreen?: boolean
  highLightEvent?: (eventId: number | null) => void
  selectedEventId?: number | null
  refineGeoLocation: (bounds: Bounds) => void
  setExpandedMap: Dispatch<SetStateAction<boolean>>
  expandedMap: boolean
  hideMap: () => void
}

export const SearchMapContainer = ({
  geoJson,
  defaultFullScreen = false,
  highLightEvent,
  selectedEventId,
  refineGeoLocation,
  setExpandedMap,
  expandedMap,
  hideMap
}: SearchMapContainerProps) => {
  const [showDynamicMap, setShowDynamicMap] = useState(defaultFullScreen)
  const [showStaticMap, setShowStaticMap] = useState(!defaultFullScreen)
  return (
    <SearchMapLocationContent>
      {showDynamicMap && (
        <SearchMap
          geoJson={geoJson}
          onLoad={() => setShowStaticMap(false)}
          highLightEvent={highLightEvent}
          selectedEventId={selectedEventId}
          refineGeoLocation={refineGeoLocation}
          setExpandedMap={setExpandedMap}
          expandedMap={expandedMap}
          hideMap={hideMap}
        />
      )}
      {showStaticMap && (
        <SearchStaticMap
          pointerEventsNone={showDynamicMap}
          onMouseDown={() => setShowDynamicMap(true)}
          geoJson={geoJson}
        />
      )}
    </SearchMapLocationContent>
  )
}
